module.exports = __webpack_public_path__ + "img/bannerTopo.b0da2f3c.png";